var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import TuneIcon from '@mui/icons-material/Tune';
import { Box, IconButton, InputAdornment, Tooltip } from '@mui/material';
import React from 'react';
import { useCommonDataTableUiTranslation } from '../../hooks';
import { AdvancedSearch } from './AdvancedSearch';
import { QuickSearch } from './QuickSearch';
export const QuickAdvancedSearch = (_a) => {
    var _b, _c;
    var { search, advancedSearch, filterDependencies } = _a, props = __rest(_a, ["search", "advancedSearch", "filterDependencies"]);
    const { t } = useCommonDataTableUiTranslation();
    const anchorRef = React.useRef();
    const [anchorEl, setAnchorEl] = React.useState();
    const handleOpen = () => {
        if (anchorRef.current) {
            setAnchorEl(anchorRef.current);
        }
    };
    const handleClose = () => setAnchorEl(undefined);
    const open = Boolean(anchorEl);
    const endAdornment = (React.createElement(InputAdornment, { position: 'end' },
        React.createElement(Tooltip, { title: t('advancedSearch') },
            React.createElement(IconButton, { "aria-label": t('advancedSearch'), onClick: handleOpen }, (_b = search.endAdornmentIcon) !== null && _b !== void 0 ? _b : React.createElement(TuneIcon, null)))));
    return (React.createElement(Box, { ref: anchorRef, "data-test": props.dataTest, sx: [
            {
                flex: { xs: '1 1 0', lg: '2 1 0', xl: '1.5 1 0' },
            },
            ...(Array.isArray(search.sx) ? search.sx : [search.sx]),
        ] },
        React.createElement(QuickSearch, Object.assign({}, search, { endAdornment: endAdornment, filterData: props.filterData, onChangeFilterData: props.onChangeFilterData, sx: {
                '& .MuiOutlinedInput-root.MuiInputBase-formControl': {
                    paddingRight: 1,
                },
            }, filterDependencies: filterDependencies, "data-test": search.dataTest })),
        React.createElement(AdvancedSearch, Object.assign({}, advancedSearch, { anchorEl: anchorEl, open: open, onClose: handleClose, filterData: props.filterData, onChangeFilterData: props.onChangeFilterData, sx: [
                { width: (_c = anchorRef.current) === null || _c === void 0 ? void 0 : _c.clientWidth },
                ...(Array.isArray(advancedSearch.sx) ? advancedSearch.sx : [advancedSearch.sx]),
            ], filterDependencies: filterDependencies }))));
};
